/*
  ProtectedRoute - Route guard for role-based access
*/

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function ProtectedRoute({ children, requiredRole = 'client', allowedRoles = null }) {
    const { isAuthenticated, loading, hasRole, isRole } = useAuth();
    const location = useLocation();

    // Show loading state
    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '60vh',
                color: 'var(--muted)'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        width: 40,
                        height: 40,
                        border: '3px solid var(--border)',
                        borderTopColor: 'var(--accent)',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 16px'
                    }} />
                    <p>Chargement...</p>
                </div>
            </div>
        );
    }

    // Not authenticated - redirect to login
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check specific allowed roles (if provided)
    if (allowedRoles && allowedRoles.length > 0) {
        const hasAllowedRole = allowedRoles.some(role => isRole(role));
        if (!hasAllowedRole) {
            return <Navigate to="/unauthorized" replace />;
        }
    }
    // Check role hierarchy (if required role is specified)
    else if (requiredRole && !hasRole(requiredRole)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
}
